import React, { useState } from 'react';
import { Box, Drawer, Divider, List, Button, Grid } from '@mui/material';
import logo from '../../assets/images/logo.jpeg';
const HomeDrawer = ({ draw, setDraw }) => {
	const [tab, setTab] = useState('one');
	const [one, setTabOne] = useState(false);
	const [two, setTabTwo] = useState(false);
	const handleChange = (val) => {
		setTab(val);
	};
	return (
		<>
			<Drawer
				anchor={'left'}
				open={draw}
				PaperProps={{
					sx: { width: '80%' },
				}}
				onClose={() => {
					draw ? setDraw(false) : setDraw(true);
					// dispatch(toggleLoginDrawerModal(false));
				}}
				style={{ width: '100%' }}
				// className={styles.drawerlogin}
				onKeyDown
				classes={{
					paper: { width: '80%' },
				}}>
				<div>
					<Box
						style={{
							display: 'flex',
							// justifyContent: 'space-between',
							// padding: 15,
						}}>
						<img src={logo} style={{ height: 80 }} />
						{/* <Button style={{ border: '1px solid #148c8d' }}>
							Login\Register
						</Button> */}
					</Box>
				</div>
				<Divider />
				<Divider />
				<Box
					style={{
						display: 'flex',
						// justifyContent: 'space-between',
						paddingTop: 2,
						paddingBottom: 2,
						paddingLeft: 12,
						paddingRight: 12,
						background: '#ebebeb',
						alignItems: 'center',
						boxShadow: '0 3px 10px 0 rgb(0 0 0/19%)!important',
					}}>
					<Box
						onClick={() => handleChange('one')}
						style={{
							background: tab === 'one' ? '#fff' : '',
							borderRadius: 10,
							padding: '10px 40px',
						}}>
						<span style={{ fontSize: 12 }}>Men</span>
					</Box>
					<Box
						onClick={() => handleChange('two')}
						style={{
							background: tab === 'two' ? '#fff' : '',
							borderRadius: 10,
							padding: '10px 40px',
						}}>
						<span style={{ fontSize: 12 }}>Women</span>
					</Box>
					<Box
						onClick={() => handleChange('three')}
						style={{
							background: tab === 'three' ? '#fff' : '',
							borderRadius: 10,
							padding: '10px 40px',
						}}>
						<span style={{ fontSize: 12 }}>Kids</span>
					</Box>
				</Box>
				<Box style={{ padding: 20 }}>
					<Box
						onClick={() => (one ? setTabOne(false) : setTabOne(true))}
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<span style={{ fontSize: 12 }}>Topwear</span>
						<img
							onClick={() => (one ? setTabOne(false) : setTabOne(true))}
							src='https://www.iconpacks.net/icons/2/free-arrow-down-icon-3101-thumb.png'
							style={{ height: 20 }}
						/>
					</Box>
					{one ? (
						<Box
							mt={2}
							style={{ border: '1px solid lightgrey', padding: '20px' }}>
							<Grid container>
								{Array.from(Array(10)).map((i) => {
									return (
										<Grid item xs={3} mt={2}>
											<Box alignItems={'center'} textAlign={'center'}>
												<img
													src='https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/side_menu_image/T-shirts_J8lZ9om_SwfupAv.png?format=webp&w=300&dpr=2.0'
													style={{ height: 25 }}
												/>
												<br />
												<span style={{ fontSize: 12 }}>T-Shirts</span>
											</Box>
										</Grid>
									);
								})}
							</Grid>
						</Box>
					) : (
						''
					)}
					<Box
						onClick={() => (two ? setTabTwo(false) : setTabTwo(true))}
						mt={3}
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<span style={{ fontSize: 12 }}>Bottom Wear</span>
						<img
							onClick={() => (two ? setTabTwo(false) : setTabTwo(true))}
							src='https://www.iconpacks.net/icons/2/free-arrow-down-icon-3101-thumb.png'
							style={{ height: 20 }}
						/>
					</Box>
					{two ? (
						<Box
							mt={2}
							style={{ border: '1px solid lightgrey', padding: '20px' }}>
							<Grid container>
								{Array.from(Array(10)).map((i) => {
									return (
										<Grid item xs={3} mt={2}>
											<Box alignItems={'center'} textAlign={'center'}>
												<img
													src='https://prod-img.thesouledstore.com/public/theSoul/storage/mobile-cms-media-prod/side_menu_image/T-shirts_J8lZ9om_SwfupAv.png?format=webp&w=300&dpr=2.0'
													style={{ height: 25 }}
												/>
												<br />
												<span style={{ fontSize: 12 }}>T-Shirts</span>
											</Box>
										</Grid>
									);
								})}
							</Grid>
						</Box>
					) : (
						''
					)}
					<Box
						mt={3}
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<span style={{ fontSize: 12 }}>Topwear</span>
						<img
							src='https://www.iconpacks.net/icons/2/free-arrow-down-icon-3101-thumb.png'
							style={{ height: 20 }}
						/>
					</Box>
					<Box
						mt={3}
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<span style={{ fontSize: 12 }}>Contact US</span>
					</Box>
					<Box
						mt={3}
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}>
						<span style={{ fontSize: 12 }}>FAQ</span>
					</Box>
				</Box>
			</Drawer>
		</>
	);
};

export default HomeDrawer;
